import { UserType } from './types.ts'

export const getSSOStatus = (user: UserType, userType: string) => {
  if (userType !== 'student') {
    return {
      cleverEnabled: false,
      classLinkEnabled: false,
      ssoEnabled: false,
      cleverRequired: false,
      classLinkRequired: false,
      googleRequired: false,
      ssoRequired: false,
    }
  }

  const cleverEnabled = !!user?.cleverSyncEnabled
  const classLinkEnabled = !!user?.classLinkEnabled
  const ssoEnabled = cleverEnabled || classLinkEnabled

  const cleverRequired = !!user?.cleverRequired
  const classLinkRequired = !!user?.classLinkRequired
  const googleRequired = !!user?.googleRequired
  const ssoRequired = cleverRequired || classLinkRequired || googleRequired

  return {
    cleverEnabled,
    classLinkEnabled,
    ssoEnabled,
    cleverRequired,
    classLinkRequired,
    googleRequired,
    ssoRequired,
  }
}
